import React, { ReactNode } from 'react';
import { Product } from 'bootstrap/data/product/Product';

import styles from './styles.module.scss';
import Divider from 'components/divider/Divider';
import { getFormattedTerm } from 'bootstrap/data/product/Product.utils';
import { PlanSelectType } from 'subscription/singleproduct/components/plansection/PlanSection.constants';
import CloseIcon from 'assets/ic_close.svg';

type Props = {
  product: Product;
  currencyCode: string;
  planType?: PlanSelectType;
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
};

export const SlideUpPanel = ({
  product,
  planType,
  isOpen,
  currencyCode,
  children,
  onClose,
}: Props) => {
  return (
    <div className={`${styles.overlay} ${isOpen ? styles.open : ''}`}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <p>Checkout</p>
          <img
            src={CloseIcon}
            alt="Close"
            className={styles.closeBtn}
            onClick={onClose}
          />
        </div>
        <div className={styles.priceWrapper}>
          <span className={styles.period}>
            {product.getTerm(undefined, true)} Plan
          </span>
          <span className={styles.price}>
            {product.getFormattedRenewsPrice(product.currency)}
          </span>
        </div>

        {!!product.getDiscountWeekPlanUnitAmount(currencyCode) ||
          (!!product.getDiscountUnitAmount(currencyCode) && (
            <div className={styles.discountWrapper}>
              <span className={styles.period}>
                {planType === PlanSelectType.WEEK
                  ? product.getMonthProductDiscountPercentage()
                  : product.getDiscountPercentage(product.currency)}
                % welcome discount
              </span>
              <span className={styles.price}>
                -
                {planType === PlanSelectType.WEEK
                  ? product.getDiscountWeekPlanUnitAmount(currencyCode)
                  : product.getDiscountUnitAmount(currencyCode)}
              </span>
            </div>
          ))}

        <Divider isDividerWithNoMargin />

        <div className={styles.totalWrapper}>
          <span className={styles.tabel}>Total:</span>
          <span className={styles.price}>
            {planType === PlanSelectType.WEEK
              ? product.getFirstRampIntervalAmount(currencyCode)
              : product.getFormattedPrice(currencyCode)}{' '}
            first / {getFormattedTerm(planType)}
          </span>
        </div>

        <h3>Select your payment method</h3>
        {children}
      </div>
    </div>
  );
};
